/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Outsideairtemperature2Inputs */



/**
* | output |
* | --- |
* | "Fresh air temperature" |
*
* @param {Ahu_History_Key_Outsideairtemperature2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_outsideairtemperature2 = /** @type {((inputs?: Ahu_History_Key_Outsideairtemperature2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Outsideairtemperature2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Fresh air temperature")
	return /** @type {LocalizedString} */ ("Température air neuf")
});
export { ahu_history_key_outsideairtemperature2 as "ahu_history_key_outsideAirTemperature" }